export function getUser() {
    let user = JSON.parse(localStorage.getItem("user_soquo"));
    if (user) {
      return user;
    } else {
      return null;
    }
  }
  